import { Radio } from 'antd';

interface IWizrRadioGroup {
    options?: any
    onChange?: (value: any) => void
    value?: string
    disabled?: any
}

const RadioGroup = ({ options, onChange, value, disabled }: IWizrRadioGroup): JSX.Element => {

    return (
        <Radio.Group
            options={options}
            onChange={onChange}
            value={value}
            disabled={disabled}
        // optionType="button"
        // buttonStyle="solid"
        />
    )
}

export default RadioGroup;